export default __webpack_public_path__ + "resources/icons/d103-4469.png";